import React from 'react';
 
const PasswordForget = () => (
  <div>
    <h1>Password Forget</h1>
  </div>
);
 
export default PasswordForget;